import { SizeOfElement } from "../../utils";
import useHover from "../../hooks/useHover";
import useScroll from "../../hooks/useScroll";
import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./fwTooltip.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles)

const Tooltip = ({ children, content, width, style, ...props }) => {
  const [classer, setClasser] = useState();
  const ref = useRef();
  const refHover = useRef();
  const hover = useHover(ref);
  const scroll = useScroll();

  useEffect(() => {
    if (ref.current && hover) {
      const {
        elementLeft,
        elementRight,
        height,
        elementTop,
        elementBottom,
      } = SizeOfElement(ref.current);

      setClasser({
        left: elementRight > 100 ? `${elementLeft}px` : "auto",
        right: elementRight > 100 ? `auto` : `${elementRight}px`,
        top: elementBottom > 100 ? `${elementTop + height}px` : "auto",
        bottom: elementBottom > 100 ? "auto" : `${elementBottom + height}px`,
      });
    }
  }, [ref.current, hover, scroll]);

  useEffect(() => {
    let ele= document.getElementById("__tooltip");
    let div = document.createElement("div");
    ele.innerHTML = "";

    if (hover && classer) {
      div.style.width = `${width}px`;
      div.style.left = classer.left;
      div.style.right = classer.right;
      div.style.top = classer.top;
      div.style.bottom = classer.bottom;
      div.className = cx("fwTooltip");
      div.innerHTML = content;
      div.ref = refHover;
      ele.appendChild(div);
    } else {
      ele.innerHTML = "";
    }
  }, [classer, hover]);

  return (
    <span
      {...props}
      style={{ ...style }}
      ref={ref}
      className={cx("fwTooltip")}
    >
      {children}
    </span>
  );
};

export default Tooltip;
